"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var booking_request_row_1 = __importDefault(require("./booking-request-row"));
function BookingRequestDetails(_a) {
    var requests = _a.requests, rental = _a.rental;
    var unexpiredRequests = requests.filter(function (request) { return !request.is_expired; });
    var _b = (0, react_1.useState)(unexpiredRequests.length > 1), collapsed = _b[0], setCollapsed = _b[1];
    return (react_1.default.createElement("div", { id: "booking-request-header", className: " bg-white border-bottom shadow-sm p-2 m-0 d-flex flex-column mb-2 text gray" },
        react_1.default.createElement("div", { className: "d-flex justify-content-between gap-2 tl", onClick: function () { return unexpiredRequests.length > 1 && setCollapsed(!collapsed); } },
            react_1.default.createElement("p", { className: "pb-0" },
                react_1.default.createElement("a", { href: window.Routing.generate("rental_edit", {
                        rentalId: rental.id,
                        _locale: lang,
                    }), target: "_blank" },
                    rental.name,
                    " \u2022 ",
                    rental.street,
                    ", ",
                    rental.city),
                react_1.default.createElement("br", null),
                unexpiredRequests.length > 1 && (react_1.default.createElement("span", { className: "strong text" },
                    window.Translator.trans("chat.booking_request.unexpired_requests", {}, "js"),
                    ": ",
                    unexpiredRequests.length))),
            unexpiredRequests.length > 1 &&
                (collapsed ? (react_1.default.createElement("svg", { className: "icon primary mb-0 align-self-center", width: "15", height: "15" },
                    react_1.default.createElement("use", { href: "#arrow-down" }))) : (react_1.default.createElement("svg", { className: "icon primary mb-0 align-self-center", width: "15", height: "15" },
                    react_1.default.createElement("use", { href: "#arrow-up" }))))),
        unexpiredRequests.length === 0 ? (react_1.default.createElement("span", { className: "strong text" }, window.Translator.trans("chat.booking_request.no_unexpired_requests", {}, "js"))) : (!collapsed && (react_1.default.createElement("div", { id: "booking-requests", className: "container-fluid overflow-auto".concat(unexpiredRequests.length > 1 ? " mt-2 " : "") }, unexpiredRequests.map(function (request, index) {
            return (react_1.default.createElement(booking_request_row_1.default, { request: request, rental: rental, key: request.id, index: index, requests: unexpiredRequests }));
        }))))));
}
exports.default = BookingRequestDetails;
